module.exports = __webpack_public_path__ + "img/Gold Nova Master.bd542ca0.png";